// services/notificationService/subscribe.ts - services/notificationService.ts split (sub-module subscribe)

import type {Notification} from '../../types';
import { mapRowToNotification } from './map';
import { createResilientSubscription } from '../../utils/realtimeManager';


// Subscribe to new notifications (INSERT) with automatic reconnection
export function subscribeToNotifications(userId: string, callback: (notification: Notification) => void) {
  if (!userId) return null;

  const mapPayload = (payload: any): Notification => mapRowToNotification(payload.new);

  const sub = createResilientSubscription({
    channelName: `notifications-insert-${userId}`,
    event: 'INSERT',
    table: 'notifications',
    filter: `user_id=eq.${userId}`,
    callback: (payload) => callback(mapPayload(payload)),
  });

  return sub;
}



// Subscribe to notification updates (UPDATE - for read status) with automatic reconnection
export function subscribeToNotificationUpdates(userId: string, callback: (notification: Notification) => void) {
  if (!userId) return null;

  const mapPayload = (payload: any): Notification => mapRowToNotification(payload.new);

  const sub = createResilientSubscription({
    channelName: `notifications-update-${userId}`,
    event: 'UPDATE',
    table: 'notifications',
    filter: `user_id=eq.${userId}`,
    callback: (payload) => callback(mapPayload(payload)),
  });

  return sub;
}
